import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

const ContentFormLayout = (props) => {
    const {
        main,
        side,
    } = props;

    return (
        <Box
            sx={{
                alignItems: 'start',
                display: 'grid',
                gap: '22px',
                gridTemplateColumns: side ? 'minmax(0, 1fr) 308px' : 'minmax(0, 1fr)',
                width: '100%',
                '@media (max-width: 1080px)': {
                    gridTemplateColumns: 'minmax(0, 1fr)',
                },
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', minWidth: 0 }}>
                {main}
            </Box>
            {Boolean(side) && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                        position: 'sticky',
                        top: 0,
                        '@media (max-width: 1080px)': {
                            position: 'static',
                        },
                    }}
                >
                    {side}
                </Box>
            )}
        </Box>
    );
};

ContentFormLayout.propTypes = {
    main: PropTypes.node.isRequired,
    side: PropTypes.node,
};

export default React.memo(ContentFormLayout);
